import { makeStyles } from "@material-ui/core/styles";

export const useSearchPanelStyles = makeStyles(theme => ({
  searchPanel: {
    display: "flex",
    alignItems: "center",
    padding: "16px 0 0 0",
    // backgroundColor: "#131313",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      columnGap: "10px",
    },
  },
  searchPanelContent: {
    [theme.breakpoints.down("sm")]: {
      columnGap: "1px",
    },
  },
  searchPanelContentHelp: {
    display: "flex",
    alignItems: "center",
    marginRight: "48px",
    [theme.breakpoints.down("sm")]: {
      marginRight: "0",
      width: "-webkit-fill-available",
    },
  },
  searchInput: {
    position: "relative",
    borderRadius: "30px",
    border: "1px solid #363636",
    // backgroundColor: "#131313",
    padding: "4px",
    "&:hover": {
      // backgroundColor: "rgba(255, 255, 255, 0.12)",
    },
    width: "100%",
  },
  avatar: {
    width: 38,
    height: 38,
  },
  name: {
    display: "flex",
    flexDirection: "column",
  },
  searchIconWrapper: {
    position: "absolute",
    left: "12px",
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#f06ec4",
  },
  inputBase: {
    color: "white",
    width: "100%",
    "& input": {
      padding: "8px 8px 8px 0",
      paddingLeft: "calc(1em + 28px)",
      transition: "width 300ms",
      width: "100%",
      height: "100%",
    },
  },
  filterButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "white",
    textTransform: "none",
    marginLeft: "16px",
    "&:hover": {
      color: "#FE5A97",
    },
    "&:focus": {
      outline: "none",
    },
    "&:active": {
      outline: "none",
      boxShadow: "none",
    },
    "&.Mui-focusVisible": {
      outline: "none",
      boxShadow: "none",
    },
    "& .MuiButton-label": {
      display: "flex",
      alignItems: "normal",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      minWidth: "auto",
    },
  },
  tabWrapper: {
    borderRadius: "10px",
    border: "none",
    color: "#FFFFFF",
    backgroundColor: "#1F1F1F",
    display: "inline-flex",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      display: "flex",
      "& .MuiTabs-root": {
        width: "inherit",
      },
    },
  },
  tab: {
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "none",
    borderRadius: "10px",
    minWidth: "180px",
    maxWidth: "180px",
    padding: "6px 18px",
    backgroundColor: "#1F1F1F",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "38px",
      minWidth: "50%",
      maxWidth: "50%",
      flex: 1,
      width: "100%",
    },
  },
  activeTab: {
    color: "white",
    backgroundColor: "#FE5A97",
    fontWeight: 700,
    borderRadius: "10px",
    "&:focus": {
      outline: "none",
    },
    "&.Mui-focusVisible": {
      outline: "none",
      border: "none",
    },
  },
  mobileSearchInput: {
    position: "absolute",
    // top: "56px",
    left: "75%",
    transform: "translateX(-50%)",
    zIndex: 999,
    display: "flex",
    alignItems: "center",
    borderRadius: "30px",
    backgroundColor: "#1f1f1f",
    border: "1px solid #363636",
    padding: "0 16px",
    height: "40px",
    maxWidth: "215px",
    width: "90%",
    [theme.breakpoints.up("md")]: {
      // display: "none",
    },
  },
  filterIcon: {
    marginRight: theme.spacing(1),
  },

  searchResultsWrapper: {
    position: "absolute",
    top: 45, // під інпутом
    left: 20,
    right: 0,
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    // padding: "12px 16px",
    maxHeight: 300,
    maxWidth: "500px",
    overflowY: "auto",
    zIndex: 20,
    backgroundColor: "#131313",
    border: "1px solid #363636",
    [theme.breakpoints.down("sm")]: {
      left: 0,
    },
  },
  creatorName: {
    fontSize: "16px",
    fontWeight: 600,
    fontHeight: "24px",
    color: "#FFFFFF",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
  searchHelp: {
    display: "flex",
    alignItems: "center",
    margin: "0 16px",
    [theme.breakpoints.down("sm")]: {},
    [theme.breakpoints.down(400)]: {
      margin: "0 12px",
    },
  },
  creatorUserName: {
    fontSize: "11px",
    fontWeight: 600,
    fontHeight: "20px",
    color: "#FE5A97",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
  resultSection: {
    marginBottom: 12,
  },
  resultTitle: {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 6,
    color: "#FFFFFF",
  },
  resultItem: {
    // padding: "6px 0",
    padding: "12px 16px",
    color: "#FFFFFF",

    display: "flex",
    fontSize: 14,
    columnGap: "10px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    "&:hover": { background: "rgb(54, 54, 54)" },
  },
  dropdown: {
    position: "absolute",
    background: "#111",
    borderRadius: "6px",
    marginTop: "6px",
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    top: 60,
    right: 20,
    width: "110px",
    backgroundColor: "#2A2A2A",
    padding: "8px",
    gap: "4px",
    [theme.breakpoints.down("sm")]: {
      right: 52,
      top: 55,
      width: "90px",
    },
  },
  option: {
    backgroundColor: "#FFFFFF08",
    border: "none",
    padding: "8px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 400,
    fontHeight: "24px",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#FFFFFF08",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
  mobileFilterRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    padding: "0 8px",
  },
  mobileNewestButton: {
    textTransform: "none",
    fontSize: "14px",
    padding: "6px 16px",
    borderRadius: 8,
  },
  postCreationBlock: {
    width: "100%",
    backgroundColor: "#121110",
    padding: "12px 15px",
    marginTop: "24px",
    marginBottom: "24px",
    borderRadius: "16px",
    position: "relative",
  },
  postCreationContent: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      gap: "12px",
    },
  },
  userAvatar: {
    width: "83px",
    height: "83px",
    borderRadius: "50%",
    objectFit: "cover",
    flexShrink: 0,
    backgroundColor: "#363636",
    fontSize: "32px",
    fontWeight: 600,
    color: "#FFFFFF",
    [theme.breakpoints.down("sm")]: {
      width: "60px",
      height: "60px",
      fontSize: "24px",
    },
  },
  postInputWrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  postActions: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    position: "relative",
  },
  smilleButton: {
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  mobileFilesPriceContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "8px",
    paddingTop: "8px",
    borderTop: "1px solid #1F1F1F",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  postInputContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  smilleIcon: {
    width: "32px",
    height: "32px",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: "24px",
      height: "24px",
    },
  },
  boxSmile: {
    position: "absolute",
    top: "100%",
    right: 0,
    marginTop: "10px",
    zIndex: 30,
    [theme.breakpoints.down("sm")]: {
      right: -8,
    },
  },
  attachedFilesText: {
    color: "#FFFFFF",
    fontSize: "20px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  attachedFilesContainer: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    width: "max-content",
    marginLeft: "auto",
    marginRight: "12px",
  },
  mobileAttachedFilesText: {
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: 700,
  },
  attachedFilesWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  uploadIconWrapper: {
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& img": {
      width: "20px",
      height: "20px",
    },
  },
  clearFilesButton: {
    padding: "4px",
    minWidth: "auto",
    width: "20px",
    height: "20px",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "rgba(255, 120, 170, 0.1)",
    },
    "& svg": {
      width: "16px",
      height: "16px",
    },
  },
  priceInputContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      gap: "8px",
    },
  },
  priceLabel: {
    color: "#FFFFFF",
    fontSize: "20px",
    fontWeight: 400,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  priceInput: {
    width: "50px",
    color: "#FFFFFF",
    fontSize: "20px",
    border: "1px solid #747474",
    borderRadius: "4px",
    padding: "4px",
    "&::placeholder": {
      color: "#FFFFFFB2 !important",
      opacity: 1,
      fontSize: "20px",
    },
    "& input": {
      padding: "0",
      textAlign: "center",
      border: "none",
      backgroundColor: "transparent",
      fontSize: "20px",
      "&::placeholder": {
        color: "#FFFFFFB2 !important",
        opacity: 1,
        fontSize: "20px",
      },
    },
    [theme.breakpoints.down("sm")]: {
      width: "45px",
      fontSize: "16px",
      "& input": {
        fontSize: "16px",
      },
      "&::placeholder": {
        fontSize: "16px",
      },
    },
  },
  postInput: {
    width: "100%",
    color: "#FFFFFF",
    fontSize: "16px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
    "&::placeholder": {
      color: "#FFFFFFB2 !important",
      opacity: 1,
    },
    "& input": {
      padding: "0",
      width: "100%",
      border: "none",
      backgroundColor: "transparent",
      "&::placeholder": {
        color: "#FFFFFFB2 !important",
        opacity: 1,
      },
    },
  },
  imageUploadButton: {
    minWidth: "auto",
    padding: "8px",
    color: "#FFFFFF",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "#FFFFFF08",
    },
    "& svg": {
      fontSize: "24px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
        width: "22px",
        height: "22px",
      },
    },
    "& img": {
      width: "32px",
      height: "32px",
      display: "block",
      [theme.breakpoints.down("sm")]: {
        width: "22px",
        height: "22px",
      },
    },
  },
  sendButton: {
    minWidth: "auto",
    padding: "0",
    color: "#FFFFFF",
    backgroundColor: "#FE5A97",
    width: "54px",
    height: "50px",
    "&:hover": {
      backgroundColor: "#FE5A97DD",
    },
    "& svg": {
      fontSize: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "34px",
      height: "34px",
      "& svg": {
        fontSize: "16px",
      },
    },
  },
  selectedFilesContainer: {
    width: "100%",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#1a1a1a",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#363636",
      borderRadius: "3px",
    },
  },
  selectedFilesList: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: "8px",
    width: "100%",
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      height: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#1a1a1a",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#363636",
      borderRadius: "3px",
    },
    [theme.breakpoints.down("sm")]: {
      gap: "12px",
    },
  },
  filePreviewItem: {
    position: "relative",
    width: "100px",
    minWidth: "100px",
    maxWidth: "100px",
    height: "126px",
    flexShrink: 0,
    overflow: "hidden",
    borderRadius: "8px",
    [theme.breakpoints.down("sm")]: {
      width: "200px",
      minWidth: "200px",
      maxWidth: "200px",
      height: "256px",
    },
  },
  filePreview: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "8px",
    display: "block",
  },
  videoPreview: {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    borderRadius: "8px",
    "& video": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      display: "block",
    },
  },
  playButtonOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
  },
  removeFileButton: {
    position: "absolute",
    top: "4px",
    right: "4px",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    padding: "4px",
    minWidth: "auto",
    width: "24px",
    height: "24px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.8)",
    },
  },
  mediaModalPaper: {
    backgroundColor: "#131313",
    borderRadius: "12px",
  },
  mediaModalTitle: {
    borderBottom: "none",
    "& > h2": {
      padding: "40px 40px 0 40px !important",
      width: "100% !important",
      display: "flex !important",
      alignItems: "center !important",
      justifyContent: "space-between !important",
      [theme.breakpoints.down("sm")]: {
        padding: "40px 16px 0 16px !important",
      },
    },
  },
  mediaModalTitleText: {
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  mediaModalCloseButton: {
    color: "#FFFFFF",
    padding: "4px",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
  mediaModalContent: {
    padding: "32px 40px 40px 40px",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "40px",
      paddingBottom: "40px",
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },
  uploadSection: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "2px dashed #363636",
    borderRadius: "8px",
    padding: "40px 20px",
    cursor: "pointer",
    backgroundColor: "#121110",
    transition: "all 0.3s ease",
    overflow: "hidden",
    "&:hover": {
      borderColor: "#FE5A97",
      backgroundColor: "#1a1a1a",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "20px 16px",
      minHeight: "120px",
    },
  },
  uploadClickText: {
    color: "#FE5A97",
    fontSize: "20px",
    fontWeight: 700,
    textAlign: "center",
    textDecoration: "underline",
    marginBottom: "8px",
  },
  uploadDragText: {
    color: "#FFFFFF",
    fontSize: "20px",
    fontWeight: 400,
    textAlign: "center",
  },
  uploadMobileText: {
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 500,
    textAlign: "center",
  },
  modalButtonsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginTop: "20px",
  },
  uploadButton: {
    backgroundColor: "transparent",
    color: "#FFFFFF",
    height: "38px",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "none",
    border: "1px solid #FE5A97",
    width: "100%",
    "&:hover": {
      backgroundColor: "#FE5A97",
    },
    [theme.breakpoints.down("sm")]: {
      flex: 1,
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
    },
  },
  addButton: {
    backgroundColor: "#FE5A97",
    color: "#FFFFFF",
    height: "60px",
    borderRadius: "8px",
    fontSize: "20px",
    fontWeight: 600,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#FE5A97DD",
    },
    [theme.breakpoints.down("sm")]: {
      height: "38px",
      fontSize: "14px",
      flex: 1,
    },
  },
  uploadedContentTitle: {
    color: "#FFFFFF",
    fontSize: "18px",
    fontWeight: 700,
    marginBottom: "12px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  filesLimitText: {
    color: "#A3A3A3",
    fontSize: "14px",
    fontWeight: 400,
    textAlign: "left",
  },
  addFileButton: {
    position: "relative",
    width: "100px",
    minWidth: "100px",
    maxWidth: "100px",
    height: "126px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px dashed #FE5A97",
    borderRadius: "8px",
    cursor: "pointer",
    backgroundColor: "#121110",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#FE5A97",
      backgroundColor: "#1a1a1a",
    },
    [theme.breakpoints.down("sm")]: {
      width: "200px",
      minWidth: "200px",
      maxWidth: "200px",
      height: "256px",
    },
  },
  cancelButton: {
    backgroundColor: "transparent",
    color: "#FFFFFF",
    height: "60px",
    borderRadius: "8px",
    fontSize: "20px",
    fontWeight: 600,
    textTransform: "none",
    border: "1px solid #FE5A97",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderColor: "#FE5A97",
    },
  },
  addMoreButton: {
    backgroundColor: "transparent",
    color: "#FFFFFF",
    height: "38px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "none",
    border: "1px solid #FE5A97",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderColor: "#FE5A97",
    },
    "&:disabled": {
      borderColor: "#363636",
      color: "#666666",
    },
  },
  continueButton: {
    backgroundColor: "#FE5A97",
    color: "#FFFFFF",
    height: "38px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#FE5A97DD",
    },
  },
  addMediaTopButton: {
    backgroundColor: "transparent",
    color: "#FFFFFF",
    height: "38px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "none",
    border: "1px solid #FE5A97",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderColor: "#FE5A97",
    },
    "&:disabled": {
      borderColor: "#363636",
      color: "#666666",
    },
  },
  filesGradientOverlay: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    width: "60px",
    background: "linear-gradient(to left, #131313, rgba(19, 19, 19, 0))",
    pointerEvents: "none",
    zIndex: 1,
  },
  deleteAllButton: {
    backgroundColor: "transparent",
    color: "#FE5A97",
    fontSize: "14px",
    fontWeight: 400,
    textTransform: "none",
    padding: "4px 8px",
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
  paidContentContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexShrink: 0,
  },
  paidContentLabel: {
    color: "#FFFFFF",
    fontSize: "20px",
    fontWeight: 400,
    whiteSpace: "nowrap",
  },
  paidContentSwitcher: {
    width: "44px",
    height: "24px",
    backgroundColor: "#1F1F1F",
    borderRadius: "12px",
    padding: "2px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    position: "relative",
  },
  paidContentSwitcherActive: {
    backgroundColor: "#FE5A97",
    "& $paidContentSwitcherThumb": {
      transform: "translateX(20px)",
    },
  },
  paidContentSwitcherThumb: {
    width: "20px",
    height: "20px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    transition: "transform 0.3s ease",
    transform: "translateX(0)",
  },
  modalPaidContentContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  modalPaidContentLabel: {
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: 400,
    whiteSpace: "nowrap",
  },
  modalPriceInputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    maxWidth: "116px",
  },
  modalPriceLabel: {
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 400,
    whiteSpace: "nowrap",
  },
  modalPriceInputWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  modalPriceInputLabel: {
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 400,
  },
  modalPriceInput: {
    width: "100%",
    color: "#FFFFFF",
    fontSize: "14px",
    border: "1px solid #747474",
    borderRadius: "4px",
    padding: "8px",
    backgroundColor: "#1F1F1F",
    "&::placeholder": {
      color: "#A3A3A3 !important",
      opacity: 1,
      fontSize: "14px",
    },
    "& input": {
      padding: "0",
      textAlign: "left",
      border: "none",
      backgroundColor: "transparent",
      fontSize: "14px",
      color: "#FFFFFF",
      "&::placeholder": {
        color: "#A3A3A3 !important",
        opacity: 1,
        fontSize: "14px",
      },
    },
  },
  mobilePriceInputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
    marginTop: "12px",
    "& $modalPriceInput": {
      width: "100%",
    },
  },
}));
